import {
  Box,
  Stack,
  useTheme
} from '@mui/material';
import {
  CompanyContextCategoryName,
  MessageData
} from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';
import {
  LoadingMessage,
  Message,
  PickCompanyCategoryMessage
} from 'modules';

import {
  useEffect,
  useRef,
  useState
} from 'react';



export interface IMessage {
  id: string;
  content: string;
  isHistorical: boolean;
  createdTimestamp: DateTime;
  senderId: string | null;
  relevantData: MessageData | null;
}

export type ChatMessagePaneProps = {
  showLoadingState?: boolean;
  selectedPane: 'ASK' | 'HISTORY';
  messages: IMessage[];
  listedCompanyId?: string;
  ticker: string;
  onSelectContextQuestion: (contextQuestionId: string) => void;
  onSelectGlAccount: (glAccountId: string) => void;
};



export const FC = (props: ChatMessagePaneProps) => {
  const theme = useTheme();
  const elementRef = useRef<HTMLDivElement>(null);
  const [
    selectedCategoryName,
    setSelectedCategoryName
  ] = useState<CompanyContextCategoryName | null>(null);

  const date = DateTime.now().toObject();

  useEffect(() => {
    const div = elementRef.current;
    if (div) {
      _.defer(() => {
        div.scrollTo({
          behavior: 'smooth',
          top: div.scrollHeight * 2
        });
      });
    }
  }, [
    props.messages,
    props.showLoadingState,
    selectedCategoryName
  ]);

  return (
    <Box
      key={props.listedCompanyId}
      ref={elementRef}
      overflow='auto'
      display='flex'
      paddingTop='2rem'
      paddingX='1rem'
      bgcolor={theme.palette.primary.darker110}
      height='100%'
      borderTop={`1px solid ${theme.palette.primary.darker140}`}
      borderBottom={`1px solid ${theme.palette.primary.darker140}`}
    >
      {/* GENERIC MESSAGES */}
      <Stack
        direction='column'
        rowGap='1.5rem'
        flex='1 1 0'
      >
        {props.listedCompanyId ? (
          <Message.FC
            role='SHERLOCK'
            ticker={props.ticker}
            sentTimestamp={DateTime.fromObject({
              year: date.year,
              month: date.month,
              day: date.day,
              hour: date.hour,
              minute: date.minute
            })}
            message='👋 I am here to assist you as your AI guide. I’m always working hard as your prompt engineer (so you don’t have to). Choose a category below and I will make sure to support you with my expertise 🧠.'
          />

        ) : (
          <Message.FC
            role='SHERLOCK'
            ticker={props.ticker}
            sentTimestamp={DateTime.fromObject({
              year: date.year,
              month: date.month,
              day: date.day,
              hour: date.hour,
              minute: date.minute
            })}
            message='Hi! 👋 I am Sherlock. In order to start, please select a company from the left.'
          />
        )}

        {props.messages?.map((msg) => {
          return (
            <Message.FC
              key={msg.id}
              ticker={props.ticker}
              role={msg.senderId ? 'USER' : 'SHERLOCK'}
              sentTimestamp={msg.createdTimestamp}
              message={msg.content}
              relevantData={msg.relevantData}
            />
          );
        })}

        {props.showLoadingState && (<LoadingMessage.FC />)}

        {(props.listedCompanyId && props.selectedPane === 'ASK') && (
          <PickCompanyCategoryMessage.FC
            listedCompanyId={props.listedCompanyId}
            selectedCategoryName={selectedCategoryName}
            onSelectCategory={(cat) => {
              setSelectedCategoryName(cat);
            }}
            onSelectContextQuestion={props.onSelectContextQuestion}
            onSelectGlAccount={props.onSelectGlAccount}
          />
        )}
      </Stack>
    </Box>
  );
};
